module.exports = __webpack_public_path__ + "static/media/class_small_paladin.ca95d589.png";